import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Navbar from "../Components/Navbars/Navbar";
import Footer from "../Components/Footer/Footer.js";
import Sidebar from "../Components/Sidebar/Sidebar.js";
import routesIn from "../routes.js";
import styles from "../assets/jss/material-dashboard-react/layouts/adminStyle.js";
import logo from "../assets/img/logo.jpeg";
import { connect } from "react-redux";
import LanguageContext from "./LanguageContext";

let role;

const switchRoutes = (role, routesIn) => (
  <Switch>
    {routesIn.map((prop, key) => {
      if (prop.layout === "/admin" && role === 'admin') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={"adminRoute" + key}
          />
        );
      } else if (prop.layout === "/master" && role === 'admin') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={"masterRoute" + key}
          />
        )
      // CP-only role — not exposed on DataXing
    // } else if (prop.layout === "/panelist" && role === 'panelist') {
    //     return (
    //       <Route
    //         path={prop.layout + prop.path}
    //         component={prop.component}
    //         key={"panelistRoutes" + key}
    //       />
    //     )
      } else if (prop.layout === "/pm" && role === 'pm') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={"pmRoutes" + key}
          />
        )
      } else if (prop.layout === "/sub-admin" && role === 'sub-admin') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={"subAdminRoutes" + key}
          />
        )
      // CP-only role — not exposed on DataXing
    // } else if (prop.layout === "/finance" && role === 'finance') {
    //     return (
    //       <Route
    //         path={prop.layout + prop.path}
    //         component={prop.component}
    //         key={"financeRoute" + key}
    //       />
    //     )
      }
    })}
    <Redirect from="/" to={`/${role}/dashboard`} />
  </Switch>
);

const useStyles = makeStyles(styles);

function Admin({ ...rest }) {
  role = rest.role || 'admin'
  let routes = [];
  // CP-only role — not exposed on DataXing
  // if (role === 'panelist') {
  //   routes = routesIn.filter((item) => item.layout === '/panelist' || item.type === 'panelist');
  // }
  if (role === 'admin') {
    routes = routesIn.filter((item) => item.layout === '/admin' && item.type === 'admin');
  }
  if (role === 'pm') {
    routes = routesIn.filter((item) => item.layout === '/pm' && item.type === 'pm' && item.path !== '/change-logs');
  }
  if (role === 'sub-admin') {
    routes = routesIn.filter((item) => item.layout === '/sub-admin' && item.type === 'sub-admin');
  }
  // CP-only role — not exposed on DataXing
  // if (role === 'finance') {
  //   routes = routesIn.filter((item) => item.layout === '/finance' && item.type === 'finance');
  // }

  const classes = useStyles();
  const theme = useTheme();
  // Sidebar is permanent only on md (>=960px); below that, the Drawer is temporary
  // and the main panel should occupy the full viewport width.
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [color] = React.useState("purple");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(
    () => localStorage.getItem('sidebarCollapsed') === 'true'
  );
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(prev => {
      const next = !prev;
      localStorage.setItem('sidebarCollapsed', String(next));
      return next;
    });
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  React.useEffect(() => {
    window.addEventListener("resize", resizeFunction);
    return function cleanup() {
      window.removeEventListener("resize", resizeFunction);
    };
  }, []);
  const language = rest.language || 'en';
  return (
    <LanguageContext.Provider value={language}>
      <div className={classes.wrapper}>
        <Sidebar
          routes={routes}
          logoText={role === 'admin' ? "DataXing Admin" : "DataXing"}
          logo={logo}
          image=""
          handleDrawerToggle={handleDrawerToggle}
          open={mobileOpen}
          color={color}
          collapsed={sidebarCollapsed}
          onToggleCollapse={toggleSidebarCollapse}
          {...rest}
        />
        <div
          className={classes.mainPanel}
          style={
            isDesktop
              ? { width: `calc(100% - ${sidebarCollapsed ? 60 : 260}px)` }
              : { width: "100%" }
          }
        >
          <Navbar
            routes={routes}
            handleDrawerToggle={handleDrawerToggle}
            {...rest}
          />
          {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>{switchRoutes(role, routes)}</div>
            </div>
          ) : (
            <div className={classes.map}>{switchRoutes(role, routes)}</div>
          )}
          {getRoute() ? <Footer /> : null}
        </div>
      </div>
    </LanguageContext.Provider>
  );
}

function mapStateToProps(state) {
  return {
    todos: state,
    role: state.adminUser.adminUser.role,
    language: state.adminUser.adminUser.language,
  };
}

export default connect(mapStateToProps)(Admin);
